<mat-accordion>
  <mat-expansion-panel class="alarm-history-panel" (opened)="fetchHistory()">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="mr-2">schedule</mat-icon>
        {{ "RECENT_ALARMS" |translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="history-content">
      @if (loading) {
        <img class="fadeLoader centerLoader logoSmall" src="assets/img/loading_logo.svg" />
      }

      @if (!loading) {
        <div>
          @for (alarm of alarms | slice:0:5; track alarm) {
            <div class="history-item">
              <div class="item-header">
                <div class="reasons-container">
                  <span class="timestamp">{{ alarm.timestamp }}</span>
                  @for (r of alarm.reasons; track r) {
                    <div class="reason-line">
                      <mat-icon class="reason-icon">warning</mat-icon>
                      <span class="reason-text">
                        @if (r.category) {
                          <span>{{ r.category }} - </span>
                          }{{ r.reason }}
                        </span>
                      </div>
                    }
                  </div>
                </div>
                <div class="comment" [class.collapsed]="alarm.collapsed">
                  @for (c of alarm.comments; track c; let i = $index) {
                    <div>
                      @if (!alarm.collapsed || i < 2) {
                        <div class="comment-row">
                          <div class="comment-user">
                            {{ c.user }}
                          </div>
                          <div class="comment-text">
                            {{ c.text }}
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
                @if (alarm.showToggle) {
                  <div
                    class="toggle-link"
                    (click)="alarm.collapsed = !alarm.collapsed"
                    >
                    {{ (alarm.collapsed ? "SHOW_MORE" : "SHOW_LESS") | translate }}
                  </div>
                }
              </div>
            }
            @if (alarms.length < 5) {
              <div class="info">
                <mat-icon>info</mat-icon>
                @if (alarms.length === 0) {
                  <span>
                    {{ "NO_ALERT_HISTORY" | translate }}
                  </span>
                }
                @if (alarms.length > 0) {
                  <span>
                    {{ "ALERTS_PAST_MONTHS" | translate:{
                    count: alarms.length,
                    months: 4
                    } }}
                  </span>
                }
              </div>
            }
          </div>
        }
      </div>
    </mat-expansion-panel>
  </mat-accordion>
